import { render } from "./CursorEmoji.vue?vue&type=template&id=7cbee6a1&scoped=true"
import script from "./CursorEmoji.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorEmoji.vue?vue&type=script&setup=true&lang=js"

import "./CursorEmoji.vue?vue&type=style&index=0&id=7cbee6a1&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbee6a1"],['__file',"src/scripts/common/sideBars/design/cursors/CursorEmoji.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cbee6a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cbee6a1', __exports__)) {
    api.reload('7cbee6a1', __exports__)
  }
  
  module.hot.accept("./CursorEmoji.vue?vue&type=template&id=7cbee6a1&scoped=true", () => {
    api.rerender('7cbee6a1', render)
  })

}


export default __exports__